import React, { Component } from 'react';
import TutorProfileLayout from './TutorProfileLayout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { history } from '../../../../helpers';
import { userActions } from '../../../../common/redux/actions';
import { Link } from 'react-router-dom';

class PaymentDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formField: {
                firstName: '',
                lastName: '',
            },
            loading: false,
        };
    }

    componentDidMount() {
        localStorage.setItem('activeStep', 4);
        const { dispatch } = this.props;
        const query = new URLSearchParams(this.props.location.search);
        const code = query.get('code');
        const state = query.get('state');
        (code && state) && dispatch(userActions.stripeConnect("POST", {code, state}, {key: 'connect'}));
    }

    stripeDisconnect() {
        const { dispatch } = this.props;
        dispatch(userActions.stripeDisconnect("DELETE", {}, {key: 'disconnect'}));
    }

    stripeRetrieve = () => {
        const { dispatch } = this.props;
        dispatch(userActions.stripeRetrieve("POST", null, {key: 'retrieve'}));
    };

    backButton = () => {
        localStorage.setItem('activeStep', 3);
        history.push('/tutor/set-availability');
    }


    render() {
        //this.validator.purgeFields();
        //const { loading } = this.state;
        const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_TEST_CLIENT_ID;
        const STRIPE_REDIRECT_URI = process.env.REACT_APP_STRIPE_REDIRECT_URI;
        const { authentication } = this.props;
        const { userProfile } = authentication.authentication.user;
        const STRIPE_STATE_VALUE = 'authorization_code';
        const isStripeConnect = ((userProfile && userProfile.strip_account_number === null) || (userProfile && userProfile.strip_account_number === '') || (userProfile && userProfile.strip_account_number === '0'));

        return (<TutorProfileLayout activeClass="TutorProfile">
            <div className="background-page">

                <div className="row">
                    <div className="col-lg-12 col-md-12 col-12 text-center mx-auto">
                        {isStripeConnect && <div className=" d-flex justify-content-center align-items-center">
                            <a target="_blank" rel="noopener noreferrer" className="btn btn-info connect-button"
                                href={`https://connect.stripe.com/express/oauth/authorize?redirect_uri=${STRIPE_REDIRECT_URI}&client_id=${STRIPE_CLIENT_ID}&state=${STRIPE_STATE_VALUE}&suggested_capabilities[]=transfers&suggested_capabilities[]=card_payments`}
                                ><span>Connect to Stripe</span></a>
                        </div>}
                    </div>
                    <div className="col-lg-12 col-md-12 col-12 text-center mx-auto">
                        <div className="align-items-center">
                            {!isStripeConnect &&
                                <button type="button" onClick={() => this.stripeDisconnect()}
                                    className="btn btn-info mr-3"> Disconnect Account </button>}
                        </div>                        
                    </div>
                </div>
                <div className="form-group text-center">
                    <hr />
                    <button className="btn btn-primary mx-2 mb-3" type="submit" onClick={this.backButton}>Back</button>
                    <Link to="/tutor/membership" className="btn btn-info mx-2 mb-3">Next</Link>
                    <hr />
                </div>

                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12 text-center mx-auto">
                        <img src="/images/b-tutor.png" width="100%"/>
                    </div>
                </div>
            </div>
        </TutorProfileLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);
const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(PaymentDetails);